import { motion } from "framer-motion";

export const GlassCard = ({ children, className = "", hover = true, ...props }) => (
  <motion.div
    whileHover={hover ? { y: -4 } : undefined}
    transition={{ duration: 0.3, ease: "easeOut" }}
    className={`rounded-2xl border border-white/10 bg-white/[0.02] backdrop-blur-xl ${
      hover ? "transition-colors duration-300 hover:border-white/20 hover:bg-white/[0.04]" : ""
    } ${className}`}
    {...props}
  >
    {children}
  </motion.div>
);
